import { useSearchParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export const useQueryParams = <T extends Record<string, any>>({
  initialData,
}: {
  isMainScreen?: boolean;
  initialData?: T;
} = {}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasInitialized = useRef(false);

  // Convert search params to object
  const currentParams = Object.fromEntries([...searchParams.entries()]);

  // Initialize with initialData if no URL params exist
  const safeParams: Record<string, any> =
    Object.keys(currentParams).length === 0
      ? { ...initialData }
      : { ...initialData, ...currentParams };

  // Handle `page`
  const parsedPage = Number(currentParams.page);
  safeParams.page =
    Number.isInteger(parsedPage) && parsedPage > 0
      ? parsedPage
      : initialData?.page || 1;

  // Handle `limit`
  const parsedLimit = Number(currentParams.limit);
  safeParams.limit =
    Number.isInteger(parsedLimit) && parsedLimit > 0
      ? parsedLimit
      : initialData?.limit || 10;

  const queryhash = JSON.stringify(safeParams);

  // useEffect(() => {
  //   if (initialData && !hasInitialized.current) {
  //     setSearchParams(
  //       Object.entries(initialData).reduce(
  //         (acc, [key, val]) => {
  //           acc[key] = String(val);
  //           return acc;
  //         },
  //         {} as Record<string, string>
  //       )
  //     );
  //     hasInitialized.current = true;
  //   }
  // }, [initialData, setSearchParams]);

  // Step 5: Utilities to update query string

  useEffect(() => {
    if (initialData && !hasInitialized.current) {
      setSearchParams(
        Object.entries(initialData).reduce(
          (acc, [key, val]) => {
            acc[key] = String(val);
            return acc;
          },
          {} as Record<string, string>
        )
      );
      hasInitialized.current = true;
    }
  }, [initialData, setSearchParams]);

 const setQuery = (params: Partial<T>) => {
  const current = Object.fromEntries([...searchParams.entries()]);
  const updated = { ...current, ...params };
  setSearchParams(updated);
};


 const updateQuery = (key: string, value: string) => {
  const current = Object.fromEntries([...searchParams.entries()]);
  const updated = { ...current, [key]: value };
  setSearchParams(updated);
};


  const setFilters = (newFilters: Partial<T>) => {
  const current = Object.fromEntries([...searchParams.entries()]);
  const updated = { ...current, ...newFilters };
  setSearchParams(updated);
};


  return {
    query: safeParams as T,
    queryhash,
    setQuery,
    updateQuery,
    filters: safeParams as T,
    setFilters,
  };
};
